import type { ParsedRow } from "./types";

// The exact rows sent to Supabase (FR-007/FR-008). `buildRows` produces the
// literal objects the receipt renders AND that are inserted — same reference, so
// "what we show" == "what we send". `user_id` is attached at insert time from the
// session (not shown here because it isn't chosen by the user).

export interface InsertRow {
  date: string;
  amount: number;
  type: "income" | "expense";
  category: string;
  account: string;
  description: string;
}

export function buildRows(rows: ParsedRow[], account: string): InsertRow[] {
  return rows.map((r) => ({
    date: r.date,
    amount: r.amount,
    type: r.type,
    category: r.category,
    account,
    description: r.description,
  }));
}

const IBAN = /[A-Z]{2}\d{2}(?:\s?[A-Z0-9]){11,30}/g;
const EMAIL = /\S+@\S+\.\S+/g;
const PHONE = /\+?\d[\d ()/-]{7,}\d/g;
const LONG_DIGITS = /\b\d[\d ]{6,}\d\b/g;
// Personal name following a transfer keyword: "an Max Mustermann", "von J. Schmidt".
const NAME_AFTER_KEYWORD = /\b(an|von|to|from|überweisung an|zahlung an|transfer to)\s+([A-ZÄÖÜ][\wäöüß.]*(?:\s+[A-ZÄÖÜ][\wäöüß.]*){0,2})/gi;

/** True if a description likely carries residual PII (IBAN, email, phone, or a
 * personal name after a transfer keyword) — used to auto-flag rows in the receipt. */
export function looksSensitive(desc: string): boolean {
  return [IBAN, EMAIL, PHONE, NAME_AFTER_KEYWORD].some((re) => {
    re.lastIndex = 0;
    return re.test(desc);
  });
}

/** Remove residual PII from a description while keeping the merchant/context. */
export function scrubDescription(desc: string): string {
  let out = desc
    .replace(IBAN, "•••")
    .replace(EMAIL, "•••")
    .replace(PHONE, "•••")
    .replace(LONG_DIGITS, "•••");
  out = out.replace(NAME_AFTER_KEYWORD, (_m, kw) => `${kw} •••`);
  return out.replace(/\s+/g, " ").trim();
}
